import React, { useEffect, useState } from 'react';
import { CardBody, Table } from "react-bootstrap";
import { useLocation } from 'react-router';
// import _axios from "axios";
import { ServerPath } from "../../../../Constant"; // Adjust path as needed
import "bootstrap/dist/css/bootstrap.min.css";
import './recentjoin.css';
import { _axios } from '../../../../utils/axios';

const RecentJoinsCardBody = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const darkMode = new URLSearchParams(location.search).get('layout') === 'dark-only';
  
  useEffect(() => {
    const fetchRecentUsers = async () => {
      try {
        setLoading(true);
        const response = await _axios.get(`${ServerPath}/users/recent`);
        console.log('Recent users data:', response.data);
        
        if (response.data.success) {
          setUsers(response.data.data || []);
        } else {
          console.error("Failed to fetch recent users:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching recent users:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRecentUsers();
  }, []);

  // Format the full name by combining user_name and last_name
  const formatName = (user) => {
    return `${user.user_name || ''} ${user.last_name || ''}`.trim();
  };

  // Format mobile number with spaces for readability
  const formatMobile = (mobile) => {
    if (!mobile) return 'N/A';
    
    // Basic formatting to add spaces in mobile number
    return mobile.toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
  };

  return (
    <CardBody>
      <div className='card-body pt-0'>
        <div>
          <Table responsive borderless variant={`${darkMode ? "dark" : ""}`}>
            <thead>
              <tr>
                <th><b>Sr. No</b></th>
                <th><b>Name</b></th>
                <th><b>City</b></th>
                <th><b>Mobile No.</b></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center">Loading...</td>
                </tr>
              ) : users.length > 0 ? (
                users.map((user, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <p className="mb-0">{index + 1}</p>
                        </div>
                        <div className="active-status active-online"></div>
                      </div>
                    </td>
                    <td>{formatName(user)}</td>
                    <td>{user.city || 'N/A'}</td>
                    <td><span>{formatMobile(user.mobile)}</span></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No recent users found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </CardBody>
  );
};

export default RecentJoinsCardBody;